export default __webpack_public_path__ + "static/media/down.f948c335.svg";